export const notificationsPageTranslations = {
  en: {
    notifications_title: "Notifications",
    chatnotifications_title: "Chat Notification",
    tabs_aria_label: "Notification types",
    empty_state_title: "No notifications",
    filter_7_days: "7 day",
    filter_30_days: "30 day",
    filter_90_days: "90 day",
  },
  de: {
    notifications_title: "Benachrichtigungen",
    chatnotifications_title: "Chat-Benachrichtigung",
    tabs_aria_label: "Benachrichtigungsarten",
    empty_state_title: "Keine Benachrichtigungen",
    filter_7_days: "7 Tage",
    filter_30_days: "30 Tage",
    filter_90_days: "90 Tage",
  },
  hr: {
    notifications_title: "Obavijesti",
    chatnotifications_title: "Chat obavijest",
    tabs_aria_label: "Vrste obavijesti",
    empty_state_title: "Nema obavijesti",
    filter_7_days: "7 dana",
    filter_30_days: "30 dana",
    filter_90_days: "90 dana",
  }
};
